import React, { Component } from "react";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import {
  Segment,
  Button,
  Form,
  Message,
  Popup,
  Icon
} from "semantic-ui-react";

import request from "../../utils/request";

const dateTimePicker = {
    enableTime: true,
    dateFormat: "Y-m-d H:i"
};

class AddPrize extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isLoading: false,
        isMounted: false,
        draw: props?.draw ?? {},
        drawId: props?.draw?.id ?? "",
        drawDate: props?.draw?.draw_at ?? "",
        drawAtText: props?.draw?.draw_at_text ?? "",
        event: props?.event ?? {},
        eventId: props?.eventId ?? false,
        prize: props?.draw?.title ?? "",
        timeRangeStart: props?.draw?.criteria?.start ?? "",
        timeRangeEnd: props?.draw?.criteria?.end ?? "",
        priceOptions: [],
        prices: [],
        prizes: [],
        xhrMessage: null,
        xhrStatus: null,
        start: "",
        end: "",
        prizeCount: 1,
        disableSave: false,
        minutesOffset: 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  handleChange = (e, { name, value }) => {
    if (name === "prizeCount") {
      if (isNaN(value) || value === "") {
        value = "";
      } else {
        value = Math.max(1, parseInt(value));
      }
    }
    this.setState({ [name]: value })
  };

  handleReset = () => {
    this.setState({
      drawDate: "",
      drawAtText: "",
      drawId: "",
      end: "",
      prices: [],
      prize: "",
      prizeCount: 1,
      start: "",
      disableSave: false,
      minutesOffset: 0,
      timeRangeStart: "",
      timeRangeEnd: ""
    });
  };

  handleSubmit = e => {
    this.setState({ isLoading: true, disableSave: true });

    const { drawDate, drawId, timeRangeStart, timeRangeEnd, eventId, prices, prize, prizeCount, drawAtText } = this.state;
    let payload = {
      drawDate: drawDate,
      drawId: drawId,
      end: timeRangeEnd,
      eventId: eventId,
      pricepoint: prices,
      prize: prize,
      prizeCount: prizeCount,
      start: timeRangeStart,
      draw_at_text: drawAtText
    };

    if (eventId) {
        request.post(this, "api:/event/" + eventId + "/secondary-draw", payload, this.handleResponse);
    } else {
        this.handleResponse({"success": false, "message": "Your prize could not be saved at this time"});
    }
  };

  handleResponse = resp => {
    if (resp && resp.success) this.props.fetchDraws();
    this.setState({
      isLoading: false,
      xhrStatus: resp.success ? "success" : "error",
      xhrMessage: resp.message
    }, () => {
      if (resp.success) {
        this.handleReset();
      }
    });
  };

  handleClearDate = () => { // clear flatpickr date input
    this.setState({
      drawDate: ""
    });
  }

  render() {
    const {
        xhrStatus,
        xhrMessage,
        isLoading,
        prices,
        priceOptions,
        minutesOffset,
        draw,
        disableSave,
        prizeCount,
        prize
      } = this.state;

    const isSaveDisabled = (prize === "" || prizeCount === "" || disableSave || +minutesOffset > 0);

    return (
        <Segment basic>
            <Form
                id="secondaryPrize"
                loading={isLoading}
                success={xhrStatus === "success"}
                error={xhrStatus === "error"}
                warning={+minutesOffset > 0}
            >
                <Message success content={xhrMessage} />
                <Message error content={xhrMessage} />
                <Message warning content="Scheduled draw time must end with a 0 or 5" />
                <Form.Group>
                    <Form.Input
                        name="prizeCount"
                        fluid
                        label="Quantity"
                        placeholder="Quantity"
                        value={prizeCount}
                        onChange={this.handleChange}
                        width={3}
                        required
                        disabled={this.state.drawId != ""}
                    />
                    <Form.Input
                        type="text"
                        name="prize"
                        fluid
                        label="Prize"
                        placeholder="Prize"
                        value={prize}
                        onChange={this.handleChange}
                        width={14}
                        required
                    />
                </Form.Group>
                <Form.Group inline>
                    <Form.Field disabled={draw && draw.status === 'complete'}>
                        <label>Automatically draw prize on:</label>
                        <Flatpickr
                            name="drawDate"
                            value={this.state.drawDate || ""}
                            placeholder="Draw Date"
                            options={dateTimePicker}
                            onValueUpdate={(_, str, b) => {
                                // how many minutes to add to round to nearest 0/5
                                let offset = moment(str).format("mm");
                                offset = (offset%5 != 0) ? 5 - offset%5 : 0;
                                this.setState({
                                drawDate: moment(str).add(offset, 'minutes').format("YYYY-MM-DD HH:mm"),
                                minutesOffset: offset
                                });
                            }}
                            onOpen={() => {this.setState({ disableSave: true });}}
                            onClose={() => {this.setState({ disableSave: false });}}
                        />
                    </Form.Field>
                    <Popup content='Clear automated draw time'
                        trigger={<Form.Button
                        type="button"
                        icon={"delete"}
                        size="mini"
                        color={"red"}
                        onClick={this.handleClearDate}
                        disabled={draw && draw.status === 'complete'}
                        />}
                    />
                </Form.Group>

                <Form.Group inline>
                  <Form.Field >
                    <Popup
                        trigger= {
                          <label>
                            <Icon name="help circle" color="blue" fitted /> Draw date text:
                          </label> }
                        content="Here you may enter the draw date as text. It will default to prize and event information if left blank."
                        inverted
                        wide
                    />
                  </Form.Field>
                  <Form.Input
                      type="text"
                      name="drawAtText"
                      placeholder="Draw date text"
                      value={this.state.drawAtText}
                      onChange={this.handleChange}
                      width={13}
                  />
                </Form.Group>

                <Segment>
                    <h4>Draw Criteria:</h4>
                    <Form.Group widths={2}>
                        <Form.Field disabled={(draw && draw.status === 'complete') || draw.game_id === 4}>
                            <label>Start:</label>
                            <Flatpickr
                            name="timeRangeStart"
                            value={this.state.timeRangeStart || ""}
                            placeholder="Start"
                            options={dateTimePicker}
                            onOpen={() => {this.setState({ disableSave: true });}}
                            onClose={() => {this.setState({ disableSave: false });}}
                            onChange={(_, str, b) =>
                                this.handleChange(b.element, {
                                    name: "timeRangeStart",
                                    value: str
                                })
                            }
                            />
                        </Form.Field>
                        <Form.Field disabled={(draw && draw.status === 'complete') || draw.game_id === 4}>
                            <label>End:</label>
                            <Flatpickr
                                name="timeRangeEnd"
                                value={this.state.timeRangeEnd || ""}
                                placeholder="End"
                                options={dateTimePicker}
                                onOpen={() => {this.setState({ disableSave: true });}}
                                onClose={() => {this.setState({ disableSave: false });}}
                                onChange={(_, str, b) =>
                                    this.handleChange(b.element, {
                                    name: "timeRangeEnd",
                                    value: str
                                    })
                                }
                            />
                        </Form.Field>
                    </Form.Group>
                </Segment>
                {false && <Form.Select
                    name="prices"
                    fluid
                    label="Limit to Price Point(s)"
                    placeholder="Price Point(s)"
                    multiple
                    search
                    options={priceOptions}
                    value={prices}
                    onChange={this.handleChange}
                    width={16}
                />}
                <Button
                    type="button"
                    floated="right"
                    icon="save"
                    content="Save"
                    primary
                    loading={isLoading}
                    onClick={this.handleSubmit}
                    disabled={isSaveDisabled}
                />
                <br />
            </Form>
        </Segment>
    );
  }
}

export default AddPrize;
